require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-the-world-banks-2018-global-disability-summit-commitments.json") })
        }
      }, "path---en-us-update-the-world-banks-2018-global-disability-summit-commitments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-the-world-banks-2018-global-disability-summit-commitments!./.cache/json/en-us-update-the-world-banks-2018-global-disability-summit-commitments.json
// module id = 809
// module chunks = 231608221292675